/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * The type of overwolf user session event
 * @export
 */
export const OWUserSessionEventType = {
    USER_LOGIN: 'USER_LOGIN',
    USER_SIGNUP: 'USER_SIGNUP',
    USER_RETURNING: 'USER_RETURNING'
} as const;
export type OWUserSessionEventType = typeof OWUserSessionEventType[keyof typeof OWUserSessionEventType];


export function instanceOfOWUserSessionEventType(value: any): boolean {
    for (const key in OWUserSessionEventType) {
        if (Object.prototype.hasOwnProperty.call(OWUserSessionEventType, key)) {
            if (OWUserSessionEventType[key as keyof typeof OWUserSessionEventType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function OWUserSessionEventTypeFromJSON(json: any): OWUserSessionEventType {
    return OWUserSessionEventTypeFromJSONTyped(json, false);
}

export function OWUserSessionEventTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): OWUserSessionEventType {
    return json as OWUserSessionEventType;
}

export function OWUserSessionEventTypeToJSON(value?: OWUserSessionEventType | null): any {
    return value as any;
}

export function OWUserSessionEventTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): OWUserSessionEventType {
    return value as OWUserSessionEventType;
}

